<template>
	<v-card>
		<v-card-title>
			<h3>Filtri</h3>
		</v-card-title>
		<v-divider />
		<v-card-text>
			<h2 class="subtitle-1 primary--text mb-2">Range Temporale</h2>

			<v-row>
				<v-col class="d-flex justify-space-between flex-wrap">
					<v-btn class="my-2" color="primary" @click="setRange('month')">Mese</v-btn>
					<v-btn class="my-2" color="primary" @click="setRange('quarter')">Trimestre</v-btn>
					<v-btn class="my-2" color="primary" @click="setRange('year')">Anno</v-btn>
					<v-btn class="my-2" color="primary" @click="setRange('all')">Tutte</v-btn>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" sm="6">
					<v-menu
						ref="fromMenu"
						v-model="fromMenu"
						:close-on-content-click="true"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field v-model="from" label="Dal giorno" readonly v-on="on"></v-text-field>
						</template>
						<v-date-picker v-model="from" no-title scrollable actions locale="it-IT">
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menu = false">OK</v-btn>
						</v-date-picker>
					</v-menu>
				</v-col>

				<v-col cols="12" sm="6">
					<v-menu
						ref="toMenu"
						v-model="toMenu"
						:close-on-content-click="true"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field v-model="to" label="Al giorno" readonly v-on="on"></v-text-field>
						</template>
						<v-date-picker v-model="to" no-title scrollable actions locale="it-IT">
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menu = false">OK</v-btn>
						</v-date-picker>
					</v-menu>
				</v-col>
			</v-row>

			<h2 class="subtitle-1 primary--text my-2">Generali</h2>

			<v-row>
				<v-col cols="12" md="6" xl="12">
					<v-select
						label="Tipo"
						item-text="title"
						item-value="value"
						:items="[
							{ value: null, title: 'Tutte' },
							{ value: 'entrata', title: 'Entrate' },
							{ value: 'uscita', title: 'Uscite' },
						]"
						v-model="kind"
					></v-select>
				</v-col>

				<v-col cols="12" md="6" xl="12">
					<v-select
						label="Categoria"
						item-text="title"
						item-value="id"
						:items="[{ id: null, title: 'Tutte' }, ...categories]"
						v-model="category_id"
					></v-select>
				</v-col>
			</v-row>
		</v-card-text>
		<v-divider />
		<v-card-actions class="pa-3">
			<v-btn color="orange" class="ml-auto white--text" @click="reset">
				Reset Filtri
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
	name: 'Filters',

	data() {
		return {
			fromMenu: false,
			toMenu: false,
		}
	},

	props: {
		operations: { kind: Array, default: () => [] },
		categories: { kind: Array, default: () => [] },
	},

	methods: {
		...mapMutations([
			'SET_FILTRI_MOVIMENTI_FROM',
			'SET_FILTRI_MOVIMENTI_TO',
			'SET_FILTRI_MOVIMENTI_KIND',
			'SET_FILTRI_MOVIMENTI_CATEGORY_ID',

			'RESET_FILTRI_MOVIMENTI',
		]),

		setRange(mode) {
			const date = new Date()
			let firstDay, lastDay

			switch (mode) {
				case 'month':
					firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
					lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

					break
				case 'quarter':
					firstDay = new Date(date.getFullYear(), date.getMonth() - 2, 1)
					lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

					break
				case 'year':
					firstDay = new Date(date.getFullYear(), 0, 1)
					lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

					break
				case 'all':
					firstDay = new Date(2019, 8, 14)
					lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

					break
				default:
					break
			}

			this.SET_FILTRI_MOVIMENTI_FROM(this.formatDate(firstDay))
			this.SET_FILTRI_MOVIMENTI_TO(this.formatDate(lastDay))
			this.$emit('filters-changed')
		},

		formatDate(date) {
			var d = new Date(date),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear()

			if (month.length < 2) month = '0' + month
			if (day.length < 2) day = '0' + day

			return [year, month, day].join('-')
		},

		reset() {
			this.RESET_FILTRI_MOVIMENTI()
			this.$emit('filters-changed')
		},
	},

	computed: {
		...mapGetters(['getFiltriMovimenti']),
		//Vuex
		from: {
			get() {
				return this.getFiltriMovimenti.from
			},
			set(value) {
				this.SET_FILTRI_MOVIMENTI_FROM(value)
				this.$emit('filters-changed')
			},
		},
		to: {
			get() {
				return this.getFiltriMovimenti.to
			},
			set(value) {
				this.SET_FILTRI_MOVIMENTI_TO(value)
				this.$emit('filters-changed')
			},
		},
		kind: {
			get() {
				return this.getFiltriMovimenti.kind
			},
			set(value) {
				this.SET_FILTRI_MOVIMENTI_KIND(value)
				this.$emit('filters-changed')
			},
		},
		category_id: {
			get() {
				return this.getFiltriMovimenti.category_id
			},
			set(value) {
				this.SET_FILTRI_MOVIMENTI_CATEGORY_ID(value)
				this.$emit('filters-changed')
			},
		},
	},
}
</script>
